import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';
import { mediaQueries } from '../../styles/media-queries';

import { ColorToken } from '../../theme/tokens/color';

import { Box } from '../Box';
import { Text } from '../Text';
import { BlockContainer, Column } from '../Layout';
import { GlImage } from '../Image';

import {
  ParagraphWithLineBreaks as RichTextParagraph,
  InlineAnchor as RichInlineAnchor,
  handleColorType
} from '../RichText/styles';

export const MobileVersion = styled('div')`
  display: block;

  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopBlockContainer = styled(BlockContainer)`
  display: none;

  ${mediaQueries.tablet} {
    display: flex;
  }
`;

export const RelativeBox = styled(Box)`
  position: relative;
`;

export const CTAText = styled(Text)`
  margin: 0 auto;
  padding-bottom: ${({ theme }) => theme.spacing.s};
`;

export const MobileSubheadingText = styled(Text)<{
  mobileSubheadingSize?: string;
}>`
  font-size: ${({ mobileSubheadingSize }) => `${mobileSubheadingSize}rem`};
  margin: 0 auto;
  padding-bottom: ${({ theme }) => theme.spacing.m};
`;

export const MobileImage = styled(GlImage)`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopImage = styled(GlImage)<{ visibility: string }>`
  height: 100%;
  max-width: ${pxToRem(630)};
  max-height: ${pxToRem(630)};
  visibility: ${({ visibility }) => visibility};
  border-radius: ${({ theme }) => theme.borderRadius.milestoneShape};
`;

export const SubheadText = styled(Text)<{
  subheadingSize?: string;
}>`
  font-size: ${({ subheadingSize }) => `${subheadingSize}rem`};
  line-height: 1.125;
`;

export const InlineAnchor = styled(RichInlineAnchor, {
  shouldForwardProp: (prop) => prop !== 'hoverColor'
})<{
  hoverColor?: ColorToken;
}>`
  ${({ theme, hoverColor = 'lightButton' }) => `
    &:hover {
      color: ${handleColorType(theme, hoverColor)};
    }

    ${mediaQueries.desktop} {
      &:hover {
        color: 
          ${handleColorType(theme, hoverColor)};
      }
    }
  `}
`;

export const PrivacyPolicyWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ParagraphWithLineBreaks = styled(RichTextParagraph)`
  max-width: ${pxToRem(272)};

  ${mediaQueries.tablet} {
    text-align: left;
  }

  ${mediaQueries.desktop} {
    min-width: 0;
    max-width: ${pxToRem(332)};
  }
`;

export const SpacerColumn = styled(Column)`
  ${mediaQueries.tablet} {
    display: none;
  }

  ${mediaQueries.desktop} {
    display: flex;
  }
`;
